export const getDaysAgo = (dateString: string | null): string => {
  if (!dateString) return 'NA';

  const inputDate = new Date(dateString);
  if (Number.isNaN(inputDate.getTime())) return 'NA'; // Invalid date

  const currentDate = new Date();

  // check for months
  const yearsDiff = currentDate.getFullYear() - inputDate.getFullYear();
  const monthsDiff = currentDate.getMonth() - inputDate.getMonth() + yearsDiff * 12;
  if (monthsDiff >= 1) return `${monthsDiff} ${monthsDiff === 1 ? 'month' : 'months'} ago`;

  // check for days
  const timeDiff = currentDate.getTime() - inputDate.getTime();
  const daysAgo = Math.floor(timeDiff / (1000 * 3600 * 24));
  return `${daysAgo} ${daysAgo === 1 ? 'day' : 'days'} ago`;
};
